/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const riskItemEntrySchema = z.object({
  externalKey: z.string().nullish(),
  itemId: z.int(),
  name: z.string(),
  overdueByDays: z.int(),
  portfolioForecastFinish: z.iso.datetime().nullish(),
  scenarioForecastFinish: z.iso.datetime().nullish(),
  targetFinish: z.iso.datetime().nullish(),
});
